import * as serviceEndpoints from "../../config/serviceEndPoints";
import { fcaFastApi } from "../../services/authorizationService";

export const getTaskManagerList = params => fcaFastApi.get(`${serviceEndpoints.taskManagerEndPoints.getTaskManagerList}`, { params });

export const getListForCommonFilter = params =>
    fcaFastApi.get(`${serviceEndpoints.taskManagerEndPoints.getListForCommonFilter}`, { params });

export const deleteTaskManagerById = id => fcaFastApi.delete(`${serviceEndpoints.taskManagerEndPoints.getTaskManagerList}/${id}`);

export const cancelTaskManagerById = id => fcaFastApi.patch(`${serviceEndpoints.taskManagerEndPoints.getTaskManagerList}/${id}/cancel`);
